export interface NewsFeed {
  headLine?: string;
  newsDate?: number;
}

export interface Twitter {
  createdAt: number;
}
